/* eslint-disable */
import React, { Component } from 'react';
import { connect } from "react-redux";
import "./style.scss";

import { Link } from "react-router-dom";

// redux
import { getGameImages } from "../../actions/games.action";

// react video imports
import { Player } from 'video-react';

//  reactstrap imports
import { Row, Col, Button, Spinner } from 'reactstrap';

class ConnectedDetailsContent extends Component {

  componentDidMount() {
    let full_url = document.URL;
    let url_array = full_url.split('/')
    let id = url_array[url_array.length - 1];
    this.props.getGameImages(id);
  }

  render() {
    const { games, gameImages, isLoading } = this.props;

    // get id from url
    let full_url = document.URL;
    let url_array = full_url.split('/')
    let id = url_array[url_array.length - 1];

    let selectedGame = games.filter(game => game.id == id);

    return (
      <div>
        <div className="video-container">
          {
            selectedGame.length > 0 ?
              selectedGame.map(selectedGame => (
                <Player
                  key={selectedGame.id}
                  playsInline
                  poster={selectedGame.jaquette}
                  src={selectedGame.video}
                />
              ))
              :
              <div className="erro-message">
                Une erreur s'est produite, veuillez ré-essayer en cliquant sur "Magasin" puis re-sélectionnez votre jeu.
              </div>
          }
        </div>
        {
          selectedGame.length > 0 ?
            selectedGame.map(selectedGame => (
              <div className="game-details-container">
                <div className="game-details-title">
                  {selectedGame.name}
                  <img src={selectedGame.explotationsystem} alt="explotation-system" className="game-details-system-logo" />
                </div>
                <h2>
                  À propos de ce jeu
                </h2>
                <div className="game-details-description">
                  {selectedGame.longdescription}
                </div>
                <h2>
                  En images
                </h2>
                <Row>
                  {
                    isLoading === true ? (
                      gameImages.map(gameImage => (
                        <Col sm="6" key={gameImage.id} className="card-loading-container">
                          <Spinner color="light" className="card-loading-spinner" />
                        </Col>
                      ))
                    )
                      :
                      gameImages.length > 0 ?
                        gameImages.map(gameImage => (
                          <Col sm="6" key={gameImage.id}>
                            <div className="game-details-images-container">
                              <img src={gameImage.image} alt="game-images" className="game-details-gallery" />
                            </div>
                          </Col>
                        ))
                        :
                        null
                  }
                </Row>
                <div className="game-details-add-basket-container">
                  {
                    selectedGame.promo === true ?
                      <div className="game-details-discount-container">
                        - {selectedGame.promorate} % de réduction maintenant !
                      </div>
                      :
                      null
                  }
                  <Link to="/basket" className="link">
                    <Button className="game-details-add-button">
                      {selectedGame.price + ' ' + '€' + ' ' + ' | '}
                    ajouter au panier
                  </Button>
                  </Link>
                </div>
                <h2>
                  <Link to="/" className="link">
                    retour au magasin
                  </Link>
                </h2>
              </div>
            ))
            :
            null
        }
      </div>
    );
  }
}

const mstp = state => {
  return {
    games: state.gameInfo.game,
    gameImages: state.gameInfo.gameImages,
    isLoading: state.gameInfo.isLoading
  };
};

const mdtp = dispatch => ({
  getGameImages: id => dispatch(getGameImages(id))
})

const DetailsContent = connect(
  mstp,
  mdtp
)(ConnectedDetailsContent);

export default DetailsContent;